module.exports = __webpack_public_path__ + "img/logoafp.de928135.png";